/**
 * CommandPrompt — MDT command prompt (extracted from CrewLoginPage.js, iter 66).
 *
 * Thin presentational input that uppercases as you type and emits Enter key
 * events to the parent's submitCommand(). No business logic is moved here —
 * submitCommand remains on the parent (CrewLoginPage.js) because it touches
 * many pieces of parent state (systemMessages, bottomMessage, logonData).
 */
import React from "react";

export function CommandPrompt({ value, onChange, onSubmit }) {
  return (
    <div style={{ borderBottom: "1px solid #FFFFFF", margin: "0", padding: "6px 8px 6px 8px" }}>
      <div className="flex items-center gap-2">
        <input
          data-testid="command-prompt"
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onSubmit();
            }
          }}
          placeholder=""
          className="flex-1 bg-transparent border-none outline-none"
          style={{
            fontFamily: '"Courier New", monospace',
            fontSize: 16,
            fontWeight: 700,
            color: "#d8d8d8",
            textTransform: "uppercase",
            caretColor: "#00BFFF",
          }}
        />
      </div>
    </div>
  );
}

export default CommandPrompt;
